import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
	selector: 'ms-empty',
	templateUrl: './ms-empty.component.html',
	styleUrls: ['./ms-empty.component.scss'],
	encapsulation: ViewEncapsulation.None,
	standalone: false,
})
export class MsEmptyComponent implements OnInit, OnDestroy {
	/**
	 * Constructor
	 */
	constructor() {}

	// -----------------------------------------------------------------------------------------------------
	// @ Lifecycle hooks
	// -----------------------------------------------------------------------------------------------------

	/**
	 * On init
	 */
	ngOnInit(): void {}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {}

	// -----------------------------------------------------------------------------------------------------
	// @ Public methods
	// -----------------------------------------------------------------------------------------------------

	// -----------------------------------------------------------------------------------------------------
	// @ Private methods
	// -----------------------------------------------------------------------------------------------------
}
